import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './HomePage.css'; // Importazione del file CSS specifico
// import { Helmet } from 'react-helmet-async';
import {Link, useLocation} from "react-router-dom";
import ArticleCard from "../parts/ArticleCard";

function HomePage(props) {
  // Hook per accedere alle traduzioni
  const { t } = useTranslation(); // Inizializza useTranslation
  const currentLang = props.language
  const [articles, setArticles] = useState([]);
  const location = useLocation();

  // Helper per generare link localizzati
  const localizedPath = (path) => {
    // path deve iniziare con /
    if (!path.startsWith('/')) path = '/' + path;
    // Sostituisci la lingua nella url
    const parts = location.pathname.split('/');
    if (['it', 'en', 'es', 'fr', 'de', 'pt'].includes(parts[1])) {
      parts[1] = currentLang;
      return parts.slice(0, 2).join('/') + path;
    } else {
      return '/' + currentLang + path;
    }
  };

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const jsonPath = `/data/json/article/${currentLang}/home_list.json`;
        const response = await fetch(jsonPath);
        if (!response.ok) {
          console.error("Could not fetch articles:", response.status, response.statusText);
          setArticles([]);
          return;
        }
        const data = await response.json();
        setArticles(data || []);
      } catch (error) {
        console.error("Could not fetch articles:", error);
        setArticles([]);
      }
    };
    fetchArticles();
  }, [currentLang]);




  return (
      <>
        {/*<Helmet>*/}
        {/*  <script src="/externaljs/tailwindcss_3.4.17.js"></script>*/}
        {/*</Helmet>*/}
        <main>

        <section className="text-center py-20 lg:py-32" style={{
          border: "1px solid rgba(129, 140, 248, 0.1)",
          borderRadius: "20px",
          background: "linear-gradient(to right, rgba(129, 140, 248, 0.1), transparent, transparent)",
          boxShadow: "0 4px 30px rgba(0, 0, 0, 0.2)",
          // backgroundColor: "#112027"
        }}>

          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold mb-8 leading-tight">
              {currentLang === 'it' && (<> Dialoghi <span className="text-gradient">impossibili</span> per menti <span className="text-gradient">curiose</span>. </>)}
              {currentLang === 'en' && (<> <span className="text-gradient">Impossible</span> dialogues for <span className="text-gradient">curious</span> minds. </>)}
              {currentLang === 'es' && (<> Diálogos <span className="text-gradient">imposibles</span> para mentes <span className="text-gradient">curiosas</span>. </>)}
              {currentLang === 'fr' && (<> Des dialogues <span className="text-gradient">impossibles</span> pour des esprits <span className="text-gradient">curieux</span>. </>)}
              {currentLang === 'de' && (<> <span className="text-gradient">Unmögliche</span> Dialoge für <span className="text-gradient">neugierige</span> Köpfe. </>)}
              {currentLang === 'pt' && (<> Diálogos <span className="text-gradient">impossíveis</span> para mentes <span className="text-gradient">curiosas</span>. </>)}
            </h1>
            <p className="text-lg md:text-xl mb-12 max-w-2xl mx-auto with-shadow">
              {t('homePage.whatWeDo')}
            </p>
            <Link to={localizedPath('/articles')} className="bg-[#003333] hover:bg-[#009999]  text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300 ease-in-out transform hover:scale-105">{t('homePage.ctaStartReading')}</Link>
          </div>
        </section>
        <section className="py-16" id="articles">
          <h2 className="text-3xl font-bold text-center mb-12">{t('homePage.selectedArticles')}</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.length > 0 ? (
                articles.slice(-3).map(article => (<ArticleCard key={article.id || article.url} article={article} currentLang={currentLang} />))
            ) : (
                <div className="no-results">
                  <p>{t('homePage.noResults')}</p>
                </div>
            )}
          </div>
        </section>
        <section className="py-20 lg:py-32" id="about">
          <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-4 main-h-color">{t('homePage.why')}</h2>
                <p className="mb-4 with-shadow">{t('homePage.ourMissionDescriptionPart1')}</p>
                <p className="mb-4 with-shadow">{t('homePage.ourMissionDescriptionPart2')}</p>
                <p className="mb-4 with-shadow">{t('homePage.ourMissionDescriptionPart3')}</p>
                <p className="mb-4 with-shadow">{t('homePage.ourMissionDescriptionPart4')}</p>
                <p className="mb-4 with-shadow">{t('homePage.ourMissionDescriptionPart5')}</p>

            </div>
            <div className="flex justify-center items-center">
              <div className="p-8 hero-gradient rounded-full">
                <img alt="Seneca Today large logo" className="h-48 w-48 header-logo"
                     src="/img/logoBlack.png"/>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 lg:py-24">
          <div className="max-w-4xl mx-auto text-center px-4">
            <div className="relative" style={{padding: "2em"}}>
              <svg className="absolute top-0 left-0 w-12 h-12 opacity-60 -mt-4 -ml-4 main-h-color" fill="currentColor" viewBox="0 0 32 32">
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <blockquote className="text-2xl md:text-3xl font-serif italic mb-6 main-h-color leading-relaxed ">
                {t('homePage.senecaQuote')}
              </blockquote>
              <div className="text-right">
                <cite className="text-lg font-semibold text-gradient not-italic">— Seneca</cite>
                <p className="text-sm text-gray-400 mt-1">{t('homePage.senecaQuoteSource')}</p>
              </div>
              <svg className="absolute bottom-0 right-0 w-12 h-12 opacity-60 -mb-4 -mr-4 transform rotate-180 main-h-color" fill="currentColor" viewBox="0 0 32 32">
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
            </div>
          </div>
        </section>



        </main>

      </>
  );
}

export default HomePage;
